// <head> главной на трёх языках: мета на языке страницы, hreflang, canonical,
// JSON-LD (Organization, две услуги, FAQPage — перенесены с прежней главной),
// шрифты и стили главной.
import homeCss from "./home.css?url";
import chromeCss from "../site/site-chrome.css?url";
import kept from "./kept-copy.json";
import { TEST_PHOTO } from "./doors-copy";
import { HOME_FAQ, HOME_HERO, type HomeLang } from "./HomePage";
import { OG_LOCALE, socialMeta } from "@/lib/page-meta";

const SITE = "https://yolutap.com";
// Русская главная канонически — /ru (решение владельца 16.10.2026). Корень «/»
// выбирает язык сам (autoLangRedirect в src/server.ts): робот без языка
// браузера получал на «/» 302 на /az, и canonical «/» у русской страницы
// указывал поиску на азербайджанскую. x-default — /az (16.10.2026): корень
// отвечает редиректом, а x-default должен вести на страницу с 200.
const CANONICAL: Record<HomeLang, string> = { ru: `${SITE}/ru`, az: `${SITE}/az`, en: `${SITE}/en` };
const X_DEFAULT = CANONICAL.az;
const OG_IMAGE = `${SITE}/photos/home/gen-hero-teen-1136.webp`;

// FAQPage — ровно те вопросы, что видны на главной (HOME_FAQ): разметка
// для поиска не должна обещать то, чего нет на странице.
function homeJsonLd(lang: HomeLang) {
  return kept[lang].jsonld.map((block) =>
    block["@type"] === "FAQPage" && "mainEntity" in block
      ? { ...block, mainEntity: HOME_FAQ.map((i) => (block.mainEntity as unknown[])[i]) }
      : block,
  );
}

export function homeHead(lang: HomeLang) {
  const m = kept[lang].meta;
  return {
    meta: [
      ...socialMeta(m),
      { property: "og:type", content: "website" },
      { property: "og:url", content: CANONICAL[lang] },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:locale", content: OG_LOCALE[lang] },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [
      { rel: "canonical", href: CANONICAL[lang] },
      { rel: "alternate", hrefLang: "ru", href: CANONICAL.ru },
      { rel: "alternate", hrefLang: "az", href: CANONICAL.az },
      { rel: "alternate", hrefLang: "en", href: CANONICAL.en },
      { rel: "alternate", hrefLang: "x-default", href: X_DEFAULT },
      // Фото двери «тест» — LCP первого экрана: качать сразу, параллельно со
      // стилями и шрифтами. Тот же srcset/sizes, что у <img> (TEST_PHOTO).
      // На карте с пинами (HOME_HERO = "pins") фото на первом экране нет.
      ...(HOME_HERO !== "doors" ? [] : [{
        rel: "preload",
        as: "image",
        href: TEST_PHOTO.src,
        imageSrcSet: TEST_PHOTO.srcSet,
        imageSizes: TEST_PHOTO.sizes,
        fetchPriority: "high" as const,
        type: "image/webp",
      }]),
      { rel: "stylesheet", href: chromeCss },
      { rel: "stylesheet", href: homeCss },
    ],
    // «<» экранируется: текст FAQ не должен суметь закрыть тег <script>.
    scripts: [{ type: "application/ld+json", children: JSON.stringify(homeJsonLd(lang)).replace(/</g, "\\u003c") }],
  };
}
